import Button from 'components/features/pfm/Button/Button'
import { FC, useEffect, useMemo, useState } from 'react'
import { OnboardingPagePreset } from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset'
import styles from 'components/features/creditCard/creditCardOnboarding/PendingStepPage/PendingStepPage.styl'
import { Link } from 'react-router-dom'
import { sleep } from 'helpers/utilsHelpers'
import ProgressBar from 'components/atoms/ProgressBar/ProgressBar'
import { INDICATOR_CHECK_STEP } from 'components/features/pfm/StepIndicator/StepIndicator'

const PENDING_STEP_PAGE_DELAY = 10000

export const PendingStepPage: FC<{}> = () => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    async function toggleIsLoaded () {
      await sleep(PENDING_STEP_PAGE_DELAY)
      setIsLoaded(true)
    }

    toggleIsLoaded()
  })

  const cardChild = useMemo(() => !isLoaded ? (
    <div className={ styles.spinnerWrapper } data-qa-marker='submitting-card'>
      <div className={ styles.title }>
        Submitting your application...
      </div>
      <ProgressBar progressPercent={ 100 } autoLoadTime={ PENDING_STEP_PAGE_DELAY } />
    </div>
  ) : (
    <div className={ styles.note } data-qa-marker='form-note'>
      We're reviewing a few additional pieces of information.
      <br /><br />
      We'll reach out to you within 1-2 business days.
    </div>
  ), [isLoaded])

  const buttonChild = useMemo(() => isLoaded && (
    <div className={ styles.preset }>
      <Link to='/credit-card'>
        <Button
          text='Close'
          fullWidth
          qaMarker='cancel-button'
        />
      </Link>
    </div>
  ), [isLoaded])

  return (
    <OnboardingPagePreset
      step={ INDICATOR_CHECK_STEP }
      title='You’re almost done'
      card={ cardChild }
      progressPercent={ 75 }
    >
      { buttonChild}
    </OnboardingPagePreset>
  )
}
